var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-add-button",on:{"click":_vm.onClick,"touchmove":function($event){return _vm.touchmove($event)}}},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-tianjia3"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }